<div class="dialog-header"
cdkDrag 
cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle >
  <h2 mat-dialog-title>{{ title }}</h2>
  <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content class="dialog-content">
  <p [innerHTML]="message"></p>
  <mat-selection-list (selectionChange)="selectionChanged($event)" [(ngModel)]="selectedOptions" [compareWith]="itemComparer" (ngModelChange)="log($event)">
    @for (item of data.list; track item) {
        <mat-list-option [selected]="isSelected(item)" [value]="item">{{ getItemName(item) }}</mat-list-option>
    }
  </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-flat-button (click)='cancel()'>Cancel</button>
  <button mat-flat-button (click)='confirm()'>Done</button>
</mat-dialog-actions>